import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 text-left" }
const _hoisted_2 = { class: "font-bold text-base lg:text-lg" }
const _hoisted_3 = { class: "text-brown text-xs lg:text-sm mb-2" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "[&_th]:border-2 [&_th]:border-white" }
const _hoisted_6 = { class: "bg-hover h-12 text-xs lg:text-sm font-bold text-brown" }
const _hoisted_7 = { class: "[&_td]:border-2 [&_td]:border-white text-sm lg:text-base" }
const _hoisted_8 = { class: "bg-gray-300 h-12 font-black" }

import { computed } from "vue";
import { DestinyMatrix } from "@/types/destinyMatrix";
import CardComponent from "@/views/Calculators/DestinyMatrix/components/CardComponent.vue";
import { useI18n } from "vue-i18n";
import { Chakra } from "@/constants/destinyMatrix";


export default /*@__PURE__*/_defineComponent({
  __name: 'HealthMapComponent',
  props: {
    matrix: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();

function reduce(num: number): number {
  if (num <= 22) {
    return num;
  }

  while (num > 22) {
    let sum = 0;
    while (num > 0) {
      sum += num % 10;
      num = Math.floor(num / 10);
    }
    num = sum;
  }

  return num;
}

const tableContent = computed(() => {
  const matrix = props.matrix;
  if (matrix === undefined) return [];

  return [
    {
      chakraKey: "sahasrara",
      physics: matrix.r1.l,
      energy: matrix.r1.t,
      emotion: reduce(matrix.r1.l + matrix.r1.t),
    },
    {
      chakraKey: "ajna",
      physics: matrix.r2.l,
      energy: matrix.r2.t,
      emotion: reduce(matrix.r2.l + matrix.r2.t),
    },
    {
      chakraKey: "vishuddha",
      physics: matrix.r3.l,
      energy: matrix.r3.t,
      emotion: reduce(matrix.r3.l + matrix.r3.t),
    },
    {
      chakraKey: "anahata",
      physics: matrix.middle_points.l,
      energy: matrix.middle_points.t,
      emotion: reduce(matrix.middle_points.l + matrix.middle_points.t),
    },
    {
      chakraKey: "manipura",
      physics: matrix.center,
      energy: matrix.center,
      emotion: reduce(matrix.center + matrix.center),
    },
    {
      chakraKey: "swadhisthana",
      physics: matrix.r3.r,
      energy: matrix.r3.b,
      emotion: reduce(matrix.r3.r + matrix.r3.b),
    },
    {
      chakraKey: "muladhara",
      physics: matrix.r1.r,
      energy: matrix.r1.b,
      emotion: reduce(matrix.r1.r + matrix.r1.b),
    },
  ];
});
const summaryRow = computed(() => {
  let physicsSum = 0;
  let energySum = 0;
  let emotionSum = 0;
  for (const contentRow of tableContent.value) {
    physicsSum += contentRow.physics;
    energySum += contentRow.energy;
    emotionSum += contentRow.emotion;
  }

  return {
    physics: reduce(physicsSum),
    energy: reduce(energySum),
    emotion: reduce(emotionSum),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CardComponent, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.title")), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.table-title")), 1),
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("thead", _hoisted_5, [
            _createElementVNode("tr", _hoisted_6, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.chakra-name")), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.physics")), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.energy")), 1),
              _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.emotion")), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableContent.value, (tableRow) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: tableRow.chakraKey,
                style: _normalizeStyle('background-color: ' + _unref(Chakra)[tableRow.chakraKey]),
                class: _normalizeClass([
                tableRow.chakraKey === 'manipura' ? 'text-black' : 'text-white'
              , "h-12"])
              }, [
                _createElementVNode("td", null, _toDisplayString(_unref(t)(
                    `calculators.destiny-matrix.health-card.${tableRow.chakraKey}`
                  )), 1),
                _createElementVNode("td", null, _toDisplayString(tableRow.physics), 1),
                _createElementVNode("td", null, _toDisplayString(tableRow.energy), 1),
                _createElementVNode("td", null, _toDisplayString(tableRow.emotion), 1)
              ], 6))
            }), 128)),
            _createElementVNode("tr", _hoisted_8, [
              _createElementVNode("td", null, _toDisplayString(_unref(t)("calculators.destiny-matrix.health-card.summary")), 1),
              _createElementVNode("td", null, _toDisplayString(summaryRow.value.physics), 1),
              _createElementVNode("td", null, _toDisplayString(summaryRow.value.energy), 1),
              _createElementVNode("td", null, _toDisplayString(summaryRow.value.emotion), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})